import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";
import { FetchVehicleSivDataInput } from "./vehiclesApi";

export interface VehiclesState {
  fetchVehicleSivDataStatus: QueryStatus;
}

const initialStateVehicles: VehiclesState = {
  fetchVehicleSivDataStatus: "idle",
};

export const fetchVehicleSivDataAsync = createAsyncThunk(
  "fetchVehicleSivData/call",
  async (payload: FetchVehicleSivDataInput) => {
    const axios = authAxios();
    await axios.post("/vehicles/fetch_siv_data", payload);
  },
);
export const vehiclesSlice = createSlice({
  name: "vehicles",
  initialState: initialStateVehicles,
  reducers: {
    resetFetchVehicleSivDataStatus: (state) => {
      state.fetchVehicleSivDataStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicleSivDataAsync.pending, (state) => {
        state.fetchVehicleSivDataStatus = "processing";
      })
      .addCase(fetchVehicleSivDataAsync.fulfilled, (state) => {
        state.fetchVehicleSivDataStatus = "success";
      })
      .addCase(fetchVehicleSivDataAsync.rejected, (state) => {
        state.fetchVehicleSivDataStatus = "failed";
      });
  },
});

export const selectFetchVehicleSivDataStatus = (state: RootState) =>
  state.vehicles.fetchVehicleSivDataStatus;

export default vehiclesSlice.reducer;
